export function useCustomMeta(path, name, prefName) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = `${config.public.hostDomain}${config.app.baseURL}`
  const pageUrl = `${baseUrl}${route.path.replace(/^\//, '')}`
  const tdConfig = () => {
    switch (path) {
      case 'top': {
        return {
          title: '黄砂レーダー',
          description: '【黄砂情報｜ウェザーニュース】今日の黄砂状況がリアルタイムで確認できます。現在から最大12時間先までの黄砂予報を掲載中。ライブカメラで今の黄砂の様子もわかります。花粉症や洗濯物が気になる方は事前にチェック。最新の気象・防災情報は予報精度No.1ウェザーニュース。',
          keyword: '黄砂レーダー,黄砂予報,ウェザーニュース'
        }
      }
      case 'area': {
        return {
          title: `${name}の黄砂レーダー`,
          description: `【${name}の黄砂情報】${name}各地の今日の黄砂状況がリアルタイムで確認できます。現在から最大12時間先までの黄砂予報を掲載中。ライブカメラで今の黄砂の様子もわかります。花粉症や洗濯物が気になる方は事前にチェック。最新の気象・防災情報は予報精度No.1ウェザーニュース。`,
          keyword: `黄砂レーダー,${name},黄砂予報`
        }
      }
      case 'pref': {
        return {
          title: `${name}の黄砂レーダー`,
          description: `【${name}の黄砂情報】${name}内の今日の黄砂状況がリアルタイムで確認できます。現在から最大12時間先までの黄砂予報を掲載中。ライブカメラで今の黄砂の様子もわかります。花粉症や洗濯物が気になる方は事前にチェック。最新の気象・防災情報は予報精度No.1ウェザーニュース。`,
          keyword: `黄砂レーダー,${name},黄砂予報`
        }
      }
      case 'city': {
        return {
          title: `${name}の黄砂レーダー`,
          description: `【${name.replace(prefName, '')}の黄砂情報】${name}の今日の黄砂状況がリアルタイムで確認できます。現在から最大12時間先までの黄砂予報を掲載中。ライブカメラで今の黄砂の様子もわかります。花粉症や洗濯物が気になる方は事前にチェック。最新の気象・防災情報は予報精度No.1ウェザーニュース。`,
          keyword: `黄砂レーダー,${name.replace(prefName, '')},黄砂予報`
        }
      }
    }
  }

  useSeoMeta({
    ogImage: 'https://gvs.weathernews.jp/common/images/ogp/kosa@1x.png',
    ogType: 'website',
    ogSiteName: 'ウェザーニュース',
    viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    fbAppId: '1500388770270212',
    appleItunesApp: 'app-id=302955766',
    appleMobileWebAppCapable: 'yes',
    formatDetection: 'address=no'
  })
  useSeoMeta({
    title: `${tdConfig().title} - ウェザーニュース`,
    description: tdConfig().description,
    ogTitle: `${tdConfig().title} - ウェザーニュース`,
    ogDescription: tdConfig().description,
    ogUrl: pageUrl,
    appleMobileWebAppTitle: tdConfig().title,
    keywords: tdConfig().keyword
  })
  useHead({
    link: [
      { rel: 'canonical', href: pageUrl },
      { rel: 'preconnect', href: config.public.siteDataDomain, crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: config.public.siteDataDomain },
      { rel: 'dns-prefetch', href: 'https://tile.weathernews.jp' },
      { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp/' }
    ]
  })
}
